// extracted by mini-css-extract-plugin
export default {"ripple":"ViewMoreBox_ripple__X59Ys","container":"ViewMoreBox_container__fVzaV"};